module.exports = __webpack_public_path__ + "static/img/y4.866b02eb.svg";